<template>
  <div class="py-4 container-fluid">
    <div class="card mt-4 p-3 pt-0 mb-3">
      <div class="filters">
        <div class="filter">
          <label for="">Filter By Year</label>
          <v-select
            v-model="filterBy.year"
            :options="['2024', '2025']"
            @option:selected="fetchData"
          />
        </div>

        <div class="filter">
          <label for="">Filter By Month</label>
          <v-select
            v-model="filterBy.month"
            :options="[
              'All',
              'January',
              'February',
              'March',
              'April',
              'May',
              'June',
              'July',
              'August',
              'September',
              'October',
              'November',
              'December',
            ]"
            @option:selected="fetchData"
          />
        </div>

        <div class="filter">
          <label class="filter-label">Start Date From:</label>
          <input
            type="date"
            @change="updateTimestamp($event, 'startDate')"
            class="datetime-input"
            v-model="filterBy.startDate"
          />
        </div>
        <div class="filter">
          <label class="filter-label">End Date At:</label>
          <input
            type="date"
            @change="updateTimestamp($event, 'endDate')"
            class="datetime-input"
            v-model="filterBy.endDate"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <default-statistics-card
        :title="`Total Sales for ${
          filterBy.month == 'All' ? filterBy.year : filterBy.month
        }`"
        :count="overallAnalytics.total_sales"
        :percentage="{
          color: 'success',
          // value: '+12%',
          // label: 'since last month',
        }"
        menu="9 June - 12 June"
        :dropdown="[
          {
            label: 'Last 7 days',
            route: 'javascript:;',
          },
          {
            label: 'Last week',
            route: 'javascript:;',
          },
          {
            label: 'Last 30 days',
            route: 'javascript:;',
          },
        ]"
      />

      <default-statistics-card
        :title="`Total Revenue for ${
          filterBy.month == 'All' ? filterBy.year : filterBy.month
        }`"
        :count="overallAnalytics.total_revenue"
        :percentage="{
          color: 'success',
          // value: '+55%',
          // label: 'since last month',
        }"
        menu="6 May - 7 May"
        :dropdown="[
          {
            label: 'Last 7 days',
            route: 'https://creative-tim.com/',
          },
          {
            label: 'Last week',
            route: '/pages/widgets',
          },
          {
            label: 'Last 30 days',
            route: '/',
          },
        ]"
      />

      <default-statistics-card
        :title="`Avg. Revenue for ${
          filterBy.month == 'All' ? filterBy.year : filterBy.month
        }`"
        :count="overallAnalytics.avg_revenue"
        :percentage="{
          color: 'secondary',
          // value: '+$213',
          // label: 'since last month',
        }"
        menu="6 August - 9 August"
        :dropdown="[
          {
            label: 'Last 7 days',
            route: 'javascript:;',
          },
          {
            label: 'Last week',
            route: 'javascript:;',
          },
          {
            label: 'Last 30 days',
            route: 'javascript:;',
          },
        ]"
      />
    </div>
    <div class="mt-4 row">
      <!-- <div class="col-lg-4 col-sm-6">
        <channels-chart-card />
      </div> -->

      <div class="col-lg-4 col-sm-6">
        <div class="card h-100">
          <div class="p-3 pb-0 card-header">
            <div class="d-flex justify-content-between">
              <h6 class="mb-0">Sales by Jewelry Type</h6>
            </div>
          </div>
          <div class="p-3 card-body">
            <horizontal-bar-chart
              :chart="{
                labels: overallAnalytics.top_sales_by_type
                  ? overallAnalytics.top_sales_by_type.label
                  : [],
                datasets: [
                  {
                    label: 'Sales by Type',
                    data: overallAnalytics.top_sales_by_type
                      ? overallAnalytics.top_sales_by_type.values
                      : [],
                  },
                ],
              }"
            />
          </div>
        </div>
      </div>
      <div class="mt-4 col-lg-8 col-sm-6 mt-sm-0">
        <revenue-chart-card :chart="revenueLineGraph" />
      </div>
    </div>
    <div class="mt-4 row">
      <!-- <div class="col-lg-8">
        <div class="card h-100">
          <div class="p-3 pb-0 card-header">
            <div class="d-flex justify-content-between">
              <h6 class="mb-0">Sales by Jewelry Type</h6>
            </div>
          </div>
          <div class="p-3 card-body">
            <horizontal-bar-chart
              :chart="{
                labels: overallAnalytics.top_sales_by_type
                  ? overallAnalytics.top_sales_by_type.label
                  : [],
                datasets: [
                  {
                    label: 'Sales by Type',
                    data: overallAnalytics.top_sales_by_type
                      ? overallAnalytics.top_sales_by_type.values
                      : [],
                  },
                ],
              }"
            />
          </div>
        </div>
      </div> -->

      <div class="mt-4 col-lg-4 mt-lg-0">
        <!-- <div class="card">
          <div class="p-3 pb-0 card-header">
            <div class="d-flex justify-content-between">
              <h6 class="mb-0">Sales by Store</h6>
            </div>
          </div>
          <div class="p-3 card-body">
            <ul class="list-group list-group-flush list my--3">
              <li
                v-for="(sale, index) in sales"
                :key="index"
                class="px-0 border-0 list-group-item"
              >
                <div class="row align-items-center">
                  <div class="col-auto">
                    <img :src="sale.flag" alt="Country flag" />
                  </div>
                  <div class="col">
                    <p class="mb-0 text-xs font-weight-bold">Country:</p>
                    <h6 class="mb-0 text-sm">{{ sale.country }}</h6>
                  </div>
                  <div class="text-center col">
                    <p class="mb-0 text-xs font-weight-bold">Sales:</p>
                    <h6 class="mb-0 text-sm">{{ sale.sales }}</h6>
                  </div>
                  <div class="text-center col">
                    <p class="mb-0 text-xs font-weight-bold">Bounce:</p>
                    <h6 class="mb-0 text-sm">{{ sale.bounce }}</h6>
                  </div>
                </div>
                <hr
                  v-if="index !== sales.length - 1"
                  class="mt-3 mb-1 horizontal dark"
                />
              </li>
            </ul>
          </div>
        </div> -->
      </div>
    </div>
    <!-- <div class="mt-4 row">
      <div class="col-12">
        <orders-list-card
          title="Sales By Stores"
          :headers="[
            'Adress',
            'Total Orders',
            'Total Revenue',
            'Avg Revenue',
            'Top Jewelry Type',
          ]"
          :lists="salesByClient"
        />
      </div>
    </div> -->
    <div class="mt-4 row">
      <div class="col-12">
        <orders-list-card
          title="Top Selling Products"
          :headers="['Product', 'Total Revenue', 'Amt Sold', 'Revenue']"
          :lists="product_performances"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ChannelsChartCard from "./components/ChannelsChartCard.vue";
import RevenueChartCard from "./components/RevenueChartCard.vue";
import HorizontalBarChart from "./components/HorizontalBarChart.vue";
import OrdersListCard from "../../../examples/Cards/OrdersListCard.vue";
// images
import US from "@/assets/img/icons/flags/US.png";
import DE from "@/assets/img/icons/flags/DE.png";
import GB from "@/assets/img/icons/flags/GB.png";
import BR from "@/assets/img/icons/flags/BR.png";
import AU from "@/assets/img/icons/flags/AU.png";
import setTooltip from "@/assets/js/tooltip.js";
import DefaultStatisticsCard from "./components/DefaultStatisticsCard.vue";
import { DateTime } from "luxon";

import {
  collection,
  doc,
  db,
  query,
  where,
  getDoc,
  getDocs,
} from "@/config/firebaseInit.js";

export default {
  name: "Overview",
  components: {
    ChannelsChartCard,
    RevenueChartCard,
    HorizontalBarChart,
    OrdersListCard,
    DefaultStatisticsCard,
  },
  props: {
    client: {
      type: Object,
      default: () => Object.assign({}),
    },
  },
  data() {
    return {
      revenueLineGraph: {
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        datasets: [
          {
            label: "Total Rev Over Time",
            data: [],
          },
          {
            label: "Total Orders Over Time",
            data: [],
          },
        ],
      },
      product_performances: [],
      salesByClient: [],
      sales: [
        {
          country: "United States",
          sales: 2500,
          bounce: "29.9%",
          flag: US,
        },
        {
          country: "Germany",
          sales: "3.900",
          bounce: "40.22%",
          flag: DE,
        },
        {
          country: "Great Britain",
          sales: "1.400",
          bounce: "23.44%",
          flag: GB,
        },
        {
          country: "Brasil",
          sales: "562",
          bounce: "32.14%",
          flag: BR,
        },
        {
          country: "Australia",
          sales: "400",
          bounce: "56.83%",
          flag: AU,
        },
      ],
      filterBy: {
        year: "2025",
        month: "All",
        startDate: null,
        endDate: null,
      },
      overallAnalytics: {
        total_revenue: 0,
        total_customers: 0,
        avg_revenue: 0,
      },
      storeAnalytics: [],
      clientId: null,
    };
  },
  watch: {
    overallAnalytics: {
      deep: true,
      handler(val) {
        this.showTypeTable = false;
        if (val.top_sales_by_type && val.top_sales_by_type.value) {
          this.showTypeTable = true;
        }
      },
    },
    storeAnalytics: {
      deep: true,
      handler(val) {
        this.salesByClient = val.map((a) =>
          Object.assign({
            title: a.client.company,
            values: [
              a.total_sales,
              a.total_revenue,
              a.avg_revenue,
              a.top_sales_by_type,
            ],
            img: a.client.thumbnail,
          })
        );
      },
    },
  },
  created() {
    this.clientId = this.client.id || this.$store.state.authModule.admin.id;
    this.fetchData();
  },

  methods: {
    // Update timestamp for start/end date
    updateTimestamp(event, type) {
      this.filterBy[type] = DateTime.fromISO(event.target.value).toMillis();
      this.fetchData();
    },

    // Fetch data based on filters
    async fetchData() {
      if (this.filterBy.month === "All") {
        await this.fetchClientOverallYearlyAnalytics();
        await this.fetchLineGraphAnalyticsForEveryMonthOfTheYear();
      } else {
        await this.fetchSelectedMonthOverallAnalytics();
        await this.fetchLineGraphAnalyticsForSelectedMonth();
      }
    },

    // Fetch yearly analytics (all months)
    async fetchClientOverallYearlyAnalytics() {
      const { year } = this.filterBy;

      // Fetch all months for the selected year
      const analyticsRef = doc(db, `clients/${this.clientId}/analytics`, year);
      const querySnapshot = await getDoc(analyticsRef);
      let totalMonths = 12;

      const data = querySnapshot.data();

      if (!data) {
        return this.$swal({
          icon: "error",
          title: "No Records Found",
          text: `No records found for your filter options`,
          type: "error",
        });
      }
      let totalRevenue = data.total_revenue || 0;
      let totalCustomers = data.total_customers || 0;
      let product_performances = [];

      if (data.top_selling_items) {
        for (const key in data.top_selling_items) {
          if (
            Object.prototype.hasOwnProperty.call(data.top_selling_items, key)
          ) {
            const product = data.top_selling_items[key];
            const analytics = {
              title: "",
              // order: "12.821",
              values: [],
              // info: "Refund rate is lower with 97% than other products",
              img: "",
              // icon: "bold-up text-success",
            };

            analytics.title = key;
            analytics.values = [
              this.format_price(product.total_sales),
              product.amount_sold,
            ];
            analytics.img = product.thumbnail;
            analytics.order = product.type;
            analytics.total = product.total_sales;
            product_performances.push(analytics);
          }
        }
      } else {
        for (const key in data.product_performances) {
          if (
            Object.prototype.hasOwnProperty.call(data.product_performances, key)
          ) {
            const product = data.product_performances[key];
            const analytics = {
              title: "",
              // order: "12.821",
              values: [],
              // info: "Refund rate is lower with 97% than other products",
              img: "",
              // icon: "bold-up text-success",
            };

            analytics.title = key;
            analytics.values = [
              this.format_price(product.total_sales),
              product.amount_sold,
            ];
            analytics.img = product.thumbnail;
            analytics.order = product.type;
            analytics.total = product.total_sales;
            product_performances.push(analytics);
          }
        }
      }

      this.overallAnalytics = {
        total_revenue: this.format_price(totalRevenue),
        total_customers: totalCustomers,
        avg_revenue: this.format_price(totalMonths > 0 ? totalRevenue / 12 : 0),
        total_sales: data.total_sales,
      };

      this.overallAnalytics.top_sales_by_type = {
        label: Object.keys(data.top_sales_by_type),
        values: Object.values(data.top_sales_by_type),
      };

      this.product_performances = product_performances.sort(
        (a, b) => b.total - a.total
      );

      console.debug(this.overallAnalytics.top_sales_by_type);

      this.$forceUpdate();
    },

    // Fetch overall analytics
    async fetchSelectedMonthOverallAnalytics() {
      const { year, month, startDate, endDate } = this.filterBy;

      // Construct Firestore query based on filters
      let analyticsRef = collection(
        db,
        `clients/${this.clientId}/analytics/${year}/monthly_sales/${month}/daily_sales`
      );
      let q = query(analyticsRef);

      if (startDate && endDate) {
        q = query(
          analyticsRef,
          where("timestamp", ">=", startDate),
          where("timestamp", "<=", endDate)
        );
      }

      const querySnapshot = await getDocs(q);
      let totalRevenue = 0;
      let totalCustomers = 0;
      let totalDays = 0;
      let totalSales = 0;
      let topSalesByType = {};

      querySnapshot.forEach((doc) => {
        const data = doc.data();

        totalRevenue += data.total_revenue || 0;
        totalCustomers += data.total_customers || 0;
        totalDays++;
        totalSales += data.total_sales || 0;
        for (const key in data.top_sales_by_type) {
          if (
            Object.prototype.hasOwnProperty.call(data.top_sales_by_type, key)
          ) {
            const count = data.top_sales_by_type[key];
            if (!topSalesByType[key]) topSalesByType[key] = 0;
            topSalesByType[key] += count;
          }
        }
      });

      this.overallAnalytics = {
        total_revenue: this.format_price(totalRevenue),
        total_customers: totalCustomers,
        avg_revenue: this.format_price(
          totalDays > 0 ? totalRevenue / totalDays : 0
        ),
        total_sales: totalSales,
      };

      this.overallAnalytics.top_sales_by_type = {
        label: Object.keys(topSalesByType),
        values: Object.values(topSalesByType),
      };

      this.$forceUpdate();
    },

    async fetchLineGraphAnalyticsForEveryMonthOfTheYear() {
      const { year } = this.filterBy;

      // Construct Firestore query based on filters
      let analyticsRef = collection(
        db,
        `clients/${this.clientId}/analytics/${year}/monthly_sales`
      );
      let q = query(analyticsRef);
      const querySnapshot = await getDocs(q);
      const monthToIndex = {
        Jan: 0,
        Feb: 1,
        Mar: 2,
        Apr: 3,
        May: 4,
        Jun: 5,
        Jul: 6,
        Aug: 7,
        Sep: 8,
        Oct: 9,
        Nov: 10,
        Dec: 11,
      };

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        console.debug({ data });
        const month = doc.id.substring(0, 3); // Get the month abbreviation (e.g., "Jan")
        const index = monthToIndex[month];

        // Assign data to the correct index based on the month
        this.revenueLineGraph.datasets[0].data[index] = data.total_revenue || 0;
      });
    },

    async fetchLineGraphAnalyticsForSelectedMonth() {
      const { year, month } = this.filterBy;

      // Construct Firestore query based on filters

      let analyticsRef = collection(
        db,
        `clients/${this.clientId}/analytics/${year}/monthly_sales/${month}/daily_sales`
      );
      analyticsRef = query(analyticsRef);
      const querySnapshot = await getDocs(analyticsRef);
      const dayLabels = [];

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        const timestamp = doc.id; // Get the month abbreviation (e.g., "Jan")
        let dateObj = new Date(Number(timestamp));
        let date = dateObj.getDate();

        if (date != 31) {
          dayLabels.push(date);
          let index = date - 1;
          // Assign data to the correct index based on the month
          this.revenueLineGraph.datasets[0].data[index] =
            data.total_revenue || 0;
        }
      });
      this.revenueLineGraph.labels = dayLabels;
    },
    // Fetch per-client analytics
    async fetchStoresAnalytics() {
      const { year, month, startDate, endDate } = this.filterBy;

      // Fetch all clients
      const clientsRef = collection(db, "stores");
      const clientsSnapshot = await getDocs(clientsRef);
      const clients = clientsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      this.storeAnalytics = [];

      for (const client of clients) {
        let analyticsRef = collection(
          db,
          `clients/${this.clientId}/analytics/${year}/monthly_sales/${month}/daily_sales`
        );
        let q = query(analyticsRef);

        if (startDate && endDate) {
          q = query(
            analyticsRef,
            where("timestamp", ">=", startDate),
            where("timestamp", "<=", endDate)
          );
        }

        const querySnapshot = await getDocs(q);
        let totalRevenue = 0;
        let totalSales = 0;
        let totalMonths = 12;
        let topSalesByType = {};

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          totalRevenue += data.total_revenue || 0;
          totalSales += data.total_sales || 0;

          for (const key in data.top_sales_by_type) {
            if (
              Object.prototype.hasOwnProperty.call(data.top_sales_by_type, key)
            ) {
              const count = data.top_sales_by_type[key];
              if (!topSalesByType[key]) topSalesByType[key] = 0;
              topSalesByType[key] += count;
            }
          }
        });

        this.storeAnalytics.push({
          client: {
            id: client.id,
            company: client.company,
            thumbnail: client.metadata.url,
          },
          total_revenue: this.format_price(totalRevenue),
          total_sales: totalSales,
          // total_customers: totalCustomers,
          top_sales_by_type: topSalesByType,
          avg_revenue: this.format_price(
            totalMonths > 0 ? totalRevenue / totalMonths : 0
          ),
        });

        this.$forceUpdate();
      }
    },

    async fetchClientYearlyAnalytics() {
      const { year } = this.filterBy;

      this.storeAnalytics = [];
      let analyticsRef = doc(db, "clients", this.clientId, "analytics", year);
      const querySnapshot = await getDoc(analyticsRef);

      const data = querySnapshot.data();
      if (data) {
        let totalRevenue = data.total_revenue || 0;
        let totalCustomers = data.total_customers || 0;
        let totalMonths = 12;
        let totalSales = data.total_sales;
        this.storeAnalytics.push({
          store: {
            id: client.id,
            company: client.company,
            thumbnail: client.metadata.url,
          },
          total_revenue: this.format_price(totalRevenue),
          total_sales: totalSales,
          total_customers: totalCustomers,
          top_sales_by_type: data.top_sales_by_type,
          avg_revenue: this.format_price(
            totalMonths > 0 ? totalRevenue / totalMonths : 0
          ),
        });
      }
    },
  },
};
</script>
<style scoped>
.filters {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.filter {
  display: flex;
  flex-direction: column;
  gap: 8px;
  display: flex;
  flex-direction: column;
  align-content: center;
}

.datetime-input {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>